export default "__VITE_PUBLIC_ASSET__89a662cc__"